import { inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
  CanActivateFn,
} from '@angular/router';
import { KeycloakAuthGuard, KeycloakService } from 'keycloak-angular';
import { Observable } from 'rxjs';
import { CommunityPanelService } from 'src/app/modules/communities/community-panel/community-panel.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard extends KeycloakAuthGuard {
  constructor(
    protected override readonly router: Router,
    protected readonly keycloak: KeycloakService,
  ) {
    super(router, keycloak);
  }

  async isAccessAllowed(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Promise<boolean | UrlTree> {
    if (!this.authenticated) {
      await this.keycloak.login({
        redirectUri: window.location.origin + state.url,
        idpHint: environment.keycloak_idpHint,
        locale: 'es',
      });
    }

    return this.authenticated;
  }
}

export const AuthGuardFn: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
):
  | Observable<boolean | UrlTree>
  | Promise<boolean | UrlTree>
  | boolean
  | UrlTree => {
  const kc = inject(KeycloakService);
  return kc.isLoggedIn().then(authenticated => {
    if (!authenticated) {
      kc.login({
        redirectUri: window.location.origin + state.url,
        idpHint: environment.keycloak_idpHint,
        locale: 'es',
      });
    }

    return authenticated;
  });
};

export const CommunityAuthGuardFn: CanActivateFn = async (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
): Promise<boolean | UrlTree> => {
  const kc = inject(KeycloakService);
  const router = inject(Router);
  const itemId = route.params['id'];
  const communityPanelService = inject(CommunityPanelService);
  const comm = await communityPanelService.initialize(itemId);
  if (!comm) return router.createUrlTree(['/']);

  const loggedAccess =
    communityPanelService.isLoggedAccess() ||
    communityPanelService.isSuscriptionAccess();

  if (!loggedAccess) {
    return true;
  }

  return kc.isLoggedIn().then(authenticated => {
    if (!authenticated) {
      kc.login({
        redirectUri: window.location.origin + state.url,
        idpHint: environment.keycloak_idpHint,
        locale: 'es',
      });
    }

    return authenticated;
  });
};
